define('community-search',['controller'], function(controller) {
	controller.on('community/search', function() {
		$('.search-query').focus();
	});
});
